// @flow

export const requestPersistentFS = () => new Promise<any>((resolve, reject) => {
  window.requestFileSystem(window.LocalFileSystem.PERSISTENT, 0, (fs) => {
    resolve(fs);
  }, (e) => reject(e));
});

export const saveToDeviceDownloadFolder = (blob: Blob, fileName: string) => new Promise<string>((resolve, reject) => {
  if (window.cordova && window.cordova.platformId !== 'browser') {
    requestPersistentFS().then((fs) => {
      fs.root.getFile(fileName, { create: true, exclusive: false }, (fileEntry) => {
        fileEntry.createWriter((fileWriter) => {
          //
          fileWriter.onwriteend = () => {
            resolve(fileEntry.toURL());
            // resolve(window.Ionic.WebView.convertFileSrc(fileEntry.toURL()));
          };
          fileWriter.onerror = (error) => reject(error);

          fileWriter.write(blob);
          //
        }, (error) => reject(error));
      }, (error) => reject(error));
    }).catch((e) => reject(e));
  } else {
    reject();
  }
});

// The native apps' system browser. Without the InAppBrowser plugin there is no way there: never load
// the page in the app's WebView instead.
const openInSystemBrowser = (url: string): boolean => {
  if (!window.cordova.InAppBrowser) return false;
  window.cordova.InAppBrowser.open(url, '_system');
  return true;
};

// Billing pages (checkout, card, invoices) live on the API's /customer site and link back here.
// The native apps open them in Safari / the default browser: window.open would load them inside
// the app's own WebView (config.xml allows navigation to any http(s) URL). The web app hands its
// tab over to them. Returns false when the page was not opened.
export const openBillingPage = (url: ?string): boolean => {
  if (!url) return false;

  if (window.cordova) return openInSystemBrowser(url);
  window.location.assign(url);
  return true;
};

// A web page beside the app: Safari / the default browser in the native apps, a new tab on the web.
// In the apps a link with target="_blank" (or window.open) loads the page in place of the app, with
// no way back on the iPhone. Returns false when the page was not opened.
export const openInBrowser = (url: ?string): boolean => {
  if (!url) return false;

  if (window.cordova) return openInSystemBrowser(url);
  window.open(url, '_blank', 'noopener');
  return true;
};
